import React from 'react';
import ReactDOM from 'react-dom/client';
import './App.css';
//
//confirm
//1. formular is correct: 50/50 fee for distribution and buyback
//2. is FOL included in fees? if yes, how to distinguish
//3. is it ok to use the css design of the stat page. if no I'll remove it

function addDays(date, days) {
  const newDate = new Date(date.getTime());
  return new Date(newDate.setDate(newDate.getDate() + days));
};

function daysInMonth(year, month) {
  return new Date(year, month + 1, 0).getDate();
}

function numberWithCommas(x) {
  return x.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
}

function matchAndRefineData(cycleStartDate, daysInCycle, data) {
  let cycleDates = [], cycleDailyFee = [], cycleDailyVE = [], missingFeeCache = [], missingVECache = [], missingFeeIndex = [], missingVEIndex = [];

  //assign fees and veAmount
  for (let i = 0; i < daysInCycle; i++) {
    const tempDate = addDays(cycleStartDate, i);
    const tempDateString = tempDate.toString();
    const cycleStartDateString = cycleStartDate.toString();
    //console.log(currentDateString);
    const currentDate = (cycleStartDateString.indexOf('Standard Time') !== -1 && tempDateString.indexOf('Daylight Time') !== -1) ? new Date(tempDate.getTime() + 3600*1000) : tempDate;

    const mm = currentDate.getUTCMonth() + 1;
    const dd = currentDate.getUTCDate();
    const currentDateStr = `${currentDate.getUTCFullYear()}-${mm > 9 ? mm : '0' + mm}-${dd > 9 ? dd : '0' + dd}`;
    const feeIndex = data.fee.findIndex(f => f.time === currentDateStr);
    const veIndex = data.ve.findIndex(v => v.time === currentDateStr);

    cycleDates.push(currentDateStr);
    cycleDailyFee.push(feeIndex === -1 ? -1 : data.fee[feeIndex].fee);
    cycleDailyVE.push(veIndex === -1 ? -1 : data.ve[veIndex].veAmount);
  }

  //record missing index
  for (let i = 0; i <= daysInCycle; i++) {
    if (cycleDailyFee[i] === -1) missingFeeCache.push({ idx: i, amount: 0 });
    if (cycleDailyVE[i] === -1) missingVECache.push({ idx: i, amount: 0 });
  }
  //console.log(cycleDates);
  //console.log(cycleDailyFee);
  //console.log(cycleDailyVE);

  //fill missing item
  let noAvailableData = false;
  for (let miss of missingFeeCache) {
    missingFeeIndex.push(miss.idx);
    let startValue = cycleDailyFee.find(fee => fee >= 0), endValue = cycleDailyFee.findLast(fee => fee >= 0);
    noAvailableData = startValue === undefined || endValue === undefined;
    if (noAvailableData) break;
    for (let i = miss.idx - 1; i >= 0; i--) {
      if (cycleDailyFee[i] >= 0) {
        startValue = cycleDailyFee[i];
        break;
      }
    }
    for (let i = miss.idx + 1; i < cycleDailyFee.length; i++) {
      if (cycleDailyFee[i] >= 0) {
        endValue = cycleDailyFee[i];
        break;
      }
    }
    miss.amount = Math.round((startValue + endValue) / 2 * 1000000) / 1000000;
  };
  if (noAvailableData) cycleDailyFee = null; else missingFeeCache.forEach(miss => cycleDailyFee[miss.idx] = miss.amount);

  for (let miss of missingVECache) {
    missingVEIndex.push(miss.idx);
    let startValue = cycleDailyVE.find(fee => fee >= 0), endValue = cycleDailyVE.findLast(fee => fee >= 0);
    noAvailableData = startValue === undefined || endValue === undefined;
    for (let i = miss.idx - 1; i >= 0; i--) {
      if (cycleDailyVE[i] >= 0) {
        startValue = cycleDailyVE[i];
        break;
      }
    }
    for (let i = miss.idx + 1; i < cycleDailyVE.length; i++) {
      if (cycleDailyVE[i] >= 0) {
        endValue = cycleDailyVE[i];
        break;
      }
    }
    miss.amount = Math.round((startValue + endValue) / 2 * 1000000) / 1000000;
  };
  if (noAvailableData) cycleDailyVE = null; else missingVECache.forEach(miss => cycleDailyVE[miss.idx] = miss.amount);

  //console.log(cycleDailyFee);
  //console.log(cycleDailyVE);

  return { date: cycleDates, fee: cycleDailyFee, ve: cycleDailyVE, missingFeeIndex: missingFeeIndex, missingVEIndex: missingVEIndex };

}


class MonthlyDataPanel extends React.Component {
    constructor(props) {
    super(props);
    //to update: this.setState({...this.state.lastCycle, totalFees: 'someothername'});
    this.state = {
      totalDaysInLastCycle: 0,
      lastCycleTotalFee: 0,
      lastCycleAvgVE: 0,
      lastCycleDetailFee: '',
      lastCycleDetailVE: '',
      lastCycleFeePer1KVE: 0,
      lastCycleLFAPR: 'need veLFNTY balance',
      lastCyclexLFAPR: 'need veLFNTY balance',
      lastCycleStartDate: undefined,

      daysInCurrentCycle: 0,
      totalDaysInCurrentCycle: 0,
      currentCycleTotalFee: 0,
      currentCycleAvgVE: 0,
      currentCycleDetailFee: '',
      currentCycleDetailVE: '',
      currentCycleFeePer1KVE: 0,
      currentCycleLFAPR: 'need veLFNTY balance',
      currentCyclexLFAPR: 'need veLFNTY balance',
      currentCycleStartDate: undefined,

      last7DTotalFee: 0,
      last7DFeeDetailDistribution: 0,

      userVEAmount: -1,
      infoPanel: '',

      fetchPriceTimeoutId: undefined,

    }
  }

  //record data history here
  //lastPolRatio = 5007095 / (5007095 + 1238200);
  //lastPolRatioDate = 'Jul. 2022';
  //lastPolRatio = 101249 / 127804.73456835552;
  //lastPolRatioDate = 'Jan. 2023';
  //lastPolRatio = 97759 / 124232.66409403777;
  //lastPolRatioDate = 'Feb. 2023';
  //lastPolRatio = 85250 / 107170.034946542;
  //lastPolRatioDate = 'Mar. 2023';
  //lastPolRatio = 62226 / 76777.4950113493;
  //lastPolRatioDate = 'Apr. 2023';
  //lastPolRatio = 60516 / 73981.13318283658;
  //lastPolRatioDate = 'May 2023';
  //lastPolRatio = 80119 / 98484.05754488539;
  //lastPolRatioDate = 'Jun. 2023';
  //lastPolRatio = 90297 / 110282.14099390447;
  //lastPolRatioDate = 'Jul. 2023';
  //lastPolRatio = 51751 / 56009.941468358695;
  //lastPolRatioDate = 'Aug. 2023';
  //lastPolRatio = 43136 / 45578.16762579897;
  //lastPolRatioDate = 'Sep. 2023';
  //lastPolRatio = 39482 / 42413.8519530066;
  //lastPolRatioDate = 'Oct. 2023';
  //lastPolRatio = 201843 / 212898.29377325106;
  //lastPolRatioDate = 'Nov. 2023';
  //lastPolRatio = 381025 / 413854.69660398323;
  //lastPolRatioDate = 'Dec. 2023';
  //lastPolRatio = 702839 / 717681.6624585469;
  //lastPolRatioDate = 'Jan. 2024';
  //lastPolRatio = 540336 / 561942.7051336673;
  //lastPolRatioDate = 'Feb. 2024';
  //lastPolRatio = 1723260 / 1756764.6917757278;
  //lastPolRatioDate = 'Mar. 2024';
  //lastPolRatio = 1280521 / 1253311.0817334135;
  //lastPolRatioDate = 'Apr. 2024';
  //lastPolRatio = 855006 / 863163.2849156039;
  //lastPolRatioDate = 'May. 2024';
  //lastPolRatio = 627197 / 622007.2152133789;
  //lastPolRatioDate = 'Jun. 2024';
  //lastPolRatio = 620711 / 637209.1919940052
  //lastPolRatioDate = 'Jul. 2024';
  //lastPolRatio = 654532 / 655488.6511589958;
  //lastPolRatioDate = 'Aug. 2024';
  //lastPolRatio = 365237 / 375695.63451011904;
  //lastPolRatioDate = 'Sep. 2024';
  //lastPolRatio = 607050 / 654084.917631028;
  //lastPolRatioDate = 'Oct. 2024';
  //lastPolRatio = 1312116 / 1380770.0009636395;
  //lastPolRatioDate = 'Nov. 2024';
  //lastPolRatio = 2465179 / 2444886.6264013033;
  //lastPolRatioDate = 'Dec. 2024';
  //lastPolRatio = 2588774 / 2703681.959834724;
  //lastPolRatioDate = 'Jan. 2025';
  //lastPolRatio = 1368344 / 1215116.907517303;
  //lastPolRatioDate = 'Feb. 2025';
  //lastPolRatio = 578586 / 565196.2936679041;
  //lastPolRatioDate = 'Mar. 2025';
  //lastPolRatio = 717393 / 694189.2212214051;
  //lastPolRatioDate = 'Apr. 2025';
  //lastPolRatio = 304267 / 294136.4131338693;
  //lastPolRatioDate = 'May. 2025';
  //lastPolRatio = 202437 / 197669.29268923381;
  //lastPolRatioDate = 'Jun. 2025';
  //lastPolRatio = 115071 / 106958.3403547391;
  //lastPolRatioDate = 'Jul. 2025';
  //lastPolRatio = 123382 / 121970.07504458223;
  //lastPolRatioDate = 'Aug. 2025';
  //lastPolRatio = 175597 / 180108.09046000024;
  //lastPolRatioDate = 'Sep. 2025';
  lastPolRatio = 149019 / 137546.9773882633;
  lastPolRatioDate = 'Oct. 2025';

  

  updateDataSource(data) {
    //calculate cycle date
    const now = new Date();
    const currentUTCDayOfMonth = now.getUTCDate();

    //console.log(currentUTCDayOfMonth);

    const currentCycleStartDateUTS = currentUTCDayOfMonth < 22 ? Date.UTC(now.getUTCFullYear(), now.getUTCMonth() - 1, 22) : Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), 22);
    const currentCycleStartDate = new Date(currentCycleStartDateUTS);
    const daysInCurrentCycle = currentUTCDayOfMonth < 22 ? daysInMonth(currentCycleStartDate.getUTCFullYear(), currentCycleStartDate.getUTCMonth()) - 21 + currentUTCDayOfMonth : currentUTCDayOfMonth - 21;
    const totalDaysInCurrentCycle = daysInMonth(currentCycleStartDate.getUTCFullYear(), currentCycleStartDate.getUTCMonth());
    const currentCyleRefinedData = matchAndRefineData(currentCycleStartDate, daysInCurrentCycle, data);

    const lastCycleStartDateUTS = currentUTCDayOfMonth < 22 ? Date.UTC(now.getUTCFullYear(), now.getUTCMonth() - 2, 22) : Date.UTC(now.getUTCFullYear(), now.getUTCMonth() - 1, 22);
    const lastCycleStartDate = new Date(lastCycleStartDateUTS);
    const totalDaysInLastCycle = daysInMonth(lastCycleStartDate.getUTCFullYear(), lastCycleStartDate.getUTCMonth());
    const lastCyleRefinedData = matchAndRefineData(lastCycleStartDate, totalDaysInLastCycle, data);


    //console.log(currentCycleStartDate);
    //console.log(lastCycleStartDate);
    //console.log(daysInCurrentCycle);
    //console.log(totalDaysInCurrentCycle);
    //console.log(totalDaysInLastCycle);
    //console.log(currentCyleRefinedData);
    //console.log(lastCyleRefinedData);

    const updateTimeStr = 'updated at ' + new Date(data.time * 1000).toTimeString();
    let currentCycleAvgVE = 0, currentCycleDetailVE = '';
    if (currentCyleRefinedData.ve) {
      for (let i = 0; i < currentCyleRefinedData.ve.length; i++) {
        currentCycleAvgVE += currentCyleRefinedData.ve[i];
        currentCycleDetailVE += `${currentCyleRefinedData.date[i]}: ${currentCyleRefinedData.ve[i]}${currentCyleRefinedData.missingVEIndex.some(idx => idx === i) ? ` (data presumed)` : ''}\n`;
      }
      currentCycleAvgVE = currentCycleAvgVE / currentCyleRefinedData.ve.length;
    } else {
      currentCycleDetailVE = 'no data';
    }

    let currentCycleTotalFee = 0, currentCycleDetailFee = '', currentCycleFeePer1KVE = 0;
    if (currentCyleRefinedData.fee) {
      for (let i = 0; i < currentCyleRefinedData.fee.length; i++) {
        currentCycleTotalFee += currentCyleRefinedData.fee[i];
        currentCycleDetailFee += `${currentCyleRefinedData.date[i]}: $${currentCyleRefinedData.fee[i]}${currentCyleRefinedData.missingFeeIndex.some(idx => idx === i) ? ` (data presumed)` : ''}\n`;
        currentCycleFeePer1KVE += currentCyleRefinedData.fee[i] * 1000 / currentCyleRefinedData.ve[i];
      }
    } else {
      currentCycleDetailFee = 'no data';
    }

    let lastCycleAvgVE = 0, lastCycleDetailVE = '';
    if (lastCyleRefinedData.ve) {
      for (let i = 0; i < lastCyleRefinedData.ve.length; i++) {
        lastCycleAvgVE += lastCyleRefinedData.ve[i];
        lastCycleDetailVE += `${lastCyleRefinedData.date[i]}: ${lastCyleRefinedData.ve[i]}${lastCyleRefinedData.missingVEIndex.some(idx => idx === i) ? ` (data presumed)` : ''}\n`;
      }
      lastCycleAvgVE = lastCycleAvgVE / lastCyleRefinedData.ve.length;
    } else {
      lastCycleDetailVE = 'no data';
    }

    let lastCycleTotalFee = 0, lastCycleDetailFee = '', lastCycleFeePer1KVE = 0;
    if (lastCyleRefinedData.fee) {
      for (let i = 0; i < lastCyleRefinedData.fee.length; i++) {
        lastCycleTotalFee += lastCyleRefinedData.fee[i];
        lastCycleDetailFee += `${lastCyleRefinedData.date[i]}: $${lastCyleRefinedData.fee[i]}${lastCyleRefinedData.missingFeeIndex.some(idx => idx === i) ? ` (data presumed)` : ''}\n`;
        lastCycleFeePer1KVE += lastCyleRefinedData.fee[i] * 1000 / lastCyleRefinedData.ve[i];
      }
    } else {
      lastCycleDetailFee = 'no data';
    }

    const last7dTotalDays = 7;
    const last7dDaysInCurrentCycle = currentCyleRefinedData.fee.length < 7 ? currentCyleRefinedData.fee.length : 7;
    const last7dDaysInLastCycle = last7dTotalDays - last7dDaysInCurrentCycle;
    let last7DTotalFee = 0, last7DFeeDetailDistribution = '*The actual value may differ a litte\n';
    for(let i = totalDaysInLastCycle - last7dDaysInLastCycle; i < totalDaysInLastCycle; i++){
      last7DTotalFee += lastCyleRefinedData.fee[i];
      last7DFeeDetailDistribution += `${lastCyleRefinedData.date[i]}: $${Math.round(lastCyleRefinedData.fee[i] * (1 - this.lastPolRatio) * 100) / 100} + $${Math.round(lastCyleRefinedData.fee[i] * this.lastPolRatio * 100) / 100}${lastCyleRefinedData.missingFeeIndex.some(idx => idx === i) ? ` (data presumed)` : ''}\n`;
    }
    for(let i = currentCyleRefinedData.fee.length - last7dDaysInCurrentCycle; i < currentCyleRefinedData.fee.length; i++){
      last7DTotalFee += currentCyleRefinedData.fee[i];
      last7DFeeDetailDistribution += `${currentCyleRefinedData.date[i]}: $${Math.round(currentCyleRefinedData.fee[i] * (1 - this.lastPolRatio) * 100) / 100} + $${Math.round(currentCyleRefinedData.fee[i] * this.lastPolRatio * 100) / 100}${currentCyleRefinedData.missingFeeIndex.some(idx => idx === i) ? ` (data presumed)` : ''}\n`;
    }



    currentCycleDetailVE += updateTimeStr;
    currentCycleDetailFee += updateTimeStr;
    lastCycleDetailVE += updateTimeStr;
    lastCycleDetailFee += updateTimeStr;
    last7DFeeDetailDistribution += updateTimeStr;

    if (this.state.daysInCurrentCycle !== daysInCurrentCycle) this.setState({ daysInCurrentCycle: daysInCurrentCycle - 1 + (now.getUTCHours() * 60 + now.getUTCMinutes()) / 24 / 60 });
    if (this.state.totalDaysInCurrentCycle !== totalDaysInCurrentCycle) this.setState({ totalDaysInCurrentCycle: totalDaysInCurrentCycle });
    if (this.state.currentCycleTotalFee !== currentCycleTotalFee) this.setState({ currentCycleTotalFee: currentCycleTotalFee });
    if (this.state.currentCycleAvgVE !== currentCycleAvgVE) this.setState({ currentCycleAvgVE: currentCycleAvgVE });
    if (this.state.currentCycleDetailFee !== currentCycleDetailFee) this.setState({ currentCycleDetailFee: currentCycleDetailFee });
    if (this.state.currentCycleDetailVE !== currentCycleDetailVE) this.setState({ currentCycleDetailVE: currentCycleDetailVE });
    if (this.state.currentCycleFeePer1KVE !== currentCycleFeePer1KVE) this.setState({ currentCycleFeePer1KVE: currentCycleFeePer1KVE });
    if (this.state.currentCycleStartDate !== currentCycleStartDate) this.setState({ currentCycleStartDate: currentCycleStartDate });
    if (this.state.totalDaysInLastCycle !== totalDaysInLastCycle) this.setState({ totalDaysInLastCycle: totalDaysInLastCycle });
    if (this.state.lastCycleTotalFee !== lastCycleTotalFee) this.setState({ lastCycleTotalFee: lastCycleTotalFee });
    if (this.state.lastCycleAvgVE !== lastCycleAvgVE) this.setState({ lastCycleAvgVE: lastCycleAvgVE });
    if (this.state.lastCycleDetailFee !== lastCycleDetailFee) this.setState({ lastCycleDetailFee: lastCycleDetailFee });
    if (this.state.lastCycleDetailVE !== lastCycleDetailVE) this.setState({ lastCycleDetailVE: lastCycleDetailVE });
    if (this.state.lastCycleFeePer1KVE !== lastCycleFeePer1KVE) this.setState({ lastCycleFeePer1KVE: lastCycleFeePer1KVE });
    if (this.state.lastCycleStartDate !== lastCycleStartDate) this.setState({ lastCycleStartDate: lastCycleStartDate });
    if (this.state.last7DTotalFee !== last7DTotalFee) this.setState({ last7DTotalFee: last7DTotalFee });
    if (this.state.last7DFeeDetailDistribution !== last7DFeeDetailDistribution) this.setState({ last7DFeeDetailDistribution: last7DFeeDetailDistribution });

  }

  fetchJupiterPrice = (amount) => {
    amount = Math.ceil(amount);
    fetch(`https://lite-api.jup.ag/swap/v1/quote?inputMint=EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v&outputMint=LFNTYraetVioAPnGJht4yNg2aUZFXR776cMeN9VMjXp&amount=${amount * 100000}&slippageBps=50`).then(response => {
      if (!response.ok) throw new Error('Network response was not ok');
      return response.json();
    }).then(data => {
      if(!data === undefined || data.outAmount === undefined) throw new Error('data response was not ok');
      const price = data.inAmount/data.outAmount;
      const roundedPrice = Math.round(price * 10000) / 10000;
      const lastCycleAPR = parseFloat(this.getUserLastCycleReward().substring(1)) * 12 * 100 / (price * amount);
      const roundedLastCycleAPR = Math.round(lastCycleAPR * 100000) / 100000;
      const currentCycleAPR = parseFloat(this.getUserCurrentCycleReward().substring(1)) * 12 * 100 / (price * amount);
      const roundedCurrentCycleAPR = Math.round(currentCycleAPR * 100000) / 100000;
      this.setState({ lastCycleLFAPR: `${roundedLastCycleAPR}% ($${roundedPrice})`, currentCycleLFAPR: `${roundedCurrentCycleAPR}% ($${roundedPrice})`, });
    }).catch(error => {
      this.setState({ lastCycleLFAPR: 'error fetching price' + error, currentCycleLFAPR: 'error fetching price',  });
    });

    fetch(`https://lite-api.jup.ag/swap/v1/quote?inputMint=EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v&outputMint=xLfNTYy76B8Tiix3hA51Jyvc1kMSFV4sPdR7szTZsRu&amount=${amount * 100000}&slippageBps=50`).then(response => {
      if (!response.ok) throw new Error('Network response was not ok');
      return response.json();
    }).then(data => {
      if(!data === undefined || data.outAmount === undefined) throw new Error('data response was not ok');
      const price = data.inAmount/data.outAmount;
      const roundedPrice = Math.round(price * 10000) / 10000;
      const lastCycleAPR = parseFloat(this.getUserLastCycleReward().substring(1)) * 12 * 100 / (price * amount);
      const roundedLastCycleAPR = Math.round(lastCycleAPR * 100000) / 100000;
      const currentCycleAPR = parseFloat(this.getUserCurrentCycleReward().substring(1)) * 12 * 100 / (price * amount);
      const roundedCurrentCycleAPR = Math.round(currentCycleAPR * 100000) / 100000;
      this.setState({ lastCyclexLFAPR: `${roundedLastCycleAPR}% ($${roundedPrice})`, currentCyclexLFAPR: `${roundedCurrentCycleAPR}% ($${roundedPrice})`, });
    }).catch(error => {
      this.setState({ lastCyclexLFAPR: 'error fetching price', currentCyclexLFAPR: 'error fetching price',  });
    });
  }

  onveAmountChange = e => {
    if (e.target.value === '') {
      this.setState({ userVEAmount: 0, lastCycleLFAPR: 'need veLFNTY balance', lastCyclexLFAPR: 'need veLFNTY balance', currentCycleLFAPR: 'need veLFNTY balance', currentCyclexLFAPR: 'need veLFNTY balance', });
    } else {
      let v = e.target.value.toString().replaceAll(',', '');
      if(isNaN(v)) {
        this.setState({ userVEAmount: 0, lastCycleLFAPR: 'need veLFNTY balance', lastCyclexLFAPR: 'need veLFNTY balance', currentCycleLFAPR: 'need veLFNTY balance', currentCyclexLFAPR: 'need veLFNTY balance', });
        if (this.state.fetchPriceTimeoutId) clearTimeout(this.state.fetchPriceTimeoutId);
        this.setState({ fetchPriceTimeoutId: undefined });
      } else {
        const vf = parseFloat(v);
        this.setState({ userVEAmount: vf, lastCycleLFAPR: 'fetching price...', lastCyclexLFAPR: 'fetching price...', currentCycleLFAPR: 'fetching price...', currentCyclexLFAPR: 'fetching price...', });
        if (this.state.fetchPriceTimeoutId) clearTimeout(this.state.fetchPriceTimeoutId);
        const timeoutId = setTimeout(() => { this.fetchJupiterPrice(vf); }, 1000);
        this.setState({ fetchPriceTimeoutId: timeoutId });
      } 
    }
  }

  onveAmountFocus = e => {
    if (this.state.userVEAmount === -1) {
      this.setState({ userVEAmount: 0 });
    }
  }

  toggleInfoPanel = (a, b, c) => {
    if (isNaN(a) || a < 0 || a > 4) return;
    const content = [
      this.state.lastCycleDetailFee,
      this.state.lastCycleDetailVE,
      this.state.currentCycleDetailFee,
      this.state.currentCycleDetailVE,
      this.state.last7DFeeDetailDistribution,
    ];
    this.props.updateInfoPannel(b, content[a], c.screenX, c.screenY);
  };

  getCyclePeriod = (cycleStartDate) => {
    if(cycleStartDate === undefined) return '';
    let cycleDate = new Date(cycleStartDate);
    let ret = `(${cycleDate.toUTCString().substring(8, 11)} 22 to `;
    cycleDate.setMonth(cycleDate.getMonth() + 1);
    ret += `${cycleDate.toUTCString().substring(8, 11)} 21)`;
    return ret;
  }

  getUserLastCycleReward = () => {
    if(this.state.lastCycleTotalFee === 0 || this.state.lastCycleAvgVE === 0 || isNaN(this.state.userVEAmount) || this.state.userVEAmount <= 0) return '';
    //else return '$' + (Math.round(this.state.lastCycleFeePer1KVE * this.state.userVEAmount / 1000 / 2 * this.lastPolRatio * 1000000) / 1000000);
    //20240725 Lifinity DAO changes distribution from 50% to 70%
    else return '$' + (Math.round(this.state.lastCycleFeePer1KVE * this.state.userVEAmount / 1000 * 0.7 * this.lastPolRatio * 1000000) / 1000000);

  }

  getUserCurrentCycleReward = () => {
    if(this.state.daysInCurrentCycle === 0 || this.state.currentCycleTotalFee === 0 || this.state.currentCycleAvgVE === 0 || isNaN(this.state.userVEAmount) || this.state.userVEAmount <= 0)  return '';
    //else return '$' + (Math.round(this.state.currentCycleFeePer1KVE * this.state.userVEAmount / 1000 / this.state.daysInCurrentCycle * this.state.totalDaysInCurrentCycle / 2 * this.lastPolRatio * 1000000) / 1000000);
    else return '$' + (Math.round(this.state.currentCycleFeePer1KVE * this.state.userVEAmount / 1000 / this.state.daysInCurrentCycle * this.state.totalDaysInCurrentCycle * 0.7 * this.lastPolRatio * 1000000) / 1000000);
  }

  //20230825 remove FOL/POL part
  render() {
    return (
      <div>
        <div className="flex">
          <h3 className="pl-2 text-xl font-semibold tracking-wide">Your veLFNTY Balance:</h3>
          <div className="sm:px-6 relative"><input className="px-2 input-d" type="text" onChange={this.onveAmountChange} onFocus={this.onveAmountFocus} value={this.state.userVEAmount === -1 ? 'enter veLFNTY amount' : (this.state.userVEAmount === 0 ? '' : this.state.userVEAmount)}></input></div>
        </div>
        <div className="flex">
          <div className="text-base font-light py-1">*The Lifinity DAO has voted to change the distribution percentage from 50% to 70%. This calculator has been updated and is being monitored<br />**Starting from Feb. 2025 revenue from Eclipse is distributed and the "Distribution Correction" will likely remain 100+% for a while</div>
        </div>
        <figure className="card mt-5 flex flex-col p-4 md:p-8">
          <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
            <div>
              <div className="mb-2 text-2xl">Last Cycle {this.getCyclePeriod(this.state.lastCycleStartDate)}</div>
              <div className="text-base font-light py-1 text-stone-400" onMouseEnter={(e) => { this.toggleInfoPanel(0, true, e) }} onMouseLeave={(e) => { this.toggleInfoPanel(0, false, e) }}>Total Fees:  <span className="text-white">{this.state.lastCycleTotalFee === 0 ? 'updating...' : '$' + numberWithCommas(this.state.lastCycleTotalFee)}</span></div>
              <div className="text-base font-light py-1 text-stone-400">Distribution Correction (as of {this.lastPolRatioDate}):  <span className="text-white">{Math.round(this.lastPolRatio * 100000) / 1000}%</span></div>
              <div className="text-base font-light py-1 text-stone-400" onMouseEnter={(e) => { this.toggleInfoPanel(1, true, e) }} onMouseLeave={(e) => { this.toggleInfoPanel(1, false, e) }}>Daily Average veLFNTY:  <span className="text-white">{this.state.lastCycleAvgVE === 0 ? 'updating...' : numberWithCommas(this.state.lastCycleAvgVE)}</span></div>
              <div className="text-base font-light py-1 text-stone-400">Your veLFNTY:  <span className="text-white">{isNaN(this.state.userVEAmount) || this.state.userVEAmount <= 0 ? 'please input your veLFNTY balance' : numberWithCommas(this.state.userVEAmount)}</span></div>
              <div className="text-base font-light py-1 text-stone-400">Your veLFNTY Share:  <span className="text-white">{isNaN(this.state.userVEAmount) || this.state.userVEAmount <= 0 ? '' : (this.state.userVEAmount / this.state.lastCycleAvgVE * 100).toString() + '%'}</span></div>
              <div className="text-base font-light py-1 text-stone-400">Your Reward Estimation:  <span className="text-white">{this.getUserLastCycleReward()}</span></div>
              <div className="text-base font-light py-1 text-stone-400">Hypothetical LFNTY APR(see FAQ):  <span className="text-white">{this.state.lastCycleLFAPR}</span></div>
              <div className="text-base font-light py-1 text-stone-400">Hypothetical xLFNTY APR(see FAQ):  <span className="text-white">{this.state.lastCyclexLFAPR}</span></div>
            </div>
            <div>
              <div className="mb-2 text-2xl">Current Cycle {this.getCyclePeriod(this.state.currentCycleStartDate)}</div>
              <div className="text-base font-light py-1 text-stone-400" onMouseEnter={(e) => { this.toggleInfoPanel(2, true, e) }} onMouseLeave={(e) => { this.toggleInfoPanel(2, false, e) }}>Fees Until Now:  <span className="text-white">{this.state.currentCycleTotalFee === 0 ? 'updating...' : '$' + numberWithCommas(this.state.currentCycleTotalFee)}</span></div>
              <div className="text-base font-light py-1 text-stone-400">Extrapolated Fees of This Cycle:  <span className="text-white">{this.state.currentCycleTotalFee === 0 ? 'updating...' : '~$' + numberWithCommas(Math.round(this.state.currentCycleTotalFee / this.state.daysInCurrentCycle * this.state.totalDaysInCurrentCycle * 1000000) / 1000000)}</span></div>
              <div className="text-base font-light py-1 text-stone-400" onMouseEnter={(e) => { this.toggleInfoPanel(3, true, e) }} onMouseLeave={(e) => { this.toggleInfoPanel(3, false, e) }}>Daily Average veLFNTY:  <span className="text-white">{this.state.currentCycleAvgVE === 0 ? 'updating...' : numberWithCommas(this.state.currentCycleAvgVE)}</span></div>
              <div className="text-base font-light py-1 text-stone-400">Your veLFNTY Share:  <span className="text-white">{isNaN(this.state.userVEAmount) || this.state.userVEAmount <= 0 ? '' : (this.state.userVEAmount / this.state.currentCycleAvgVE * 100).toString() + '%'}</span></div>
              <div className="text-base font-light py-1 text-stone-400">Your Current Reward Estimation:  <span className="text-white">{(this.state.currentCycleTotalFee === 0 || this.state.currentCycleAvgVE === 0 || isNaN(this.state.userVEAmount) || this.state.userVEAmount <= 0) ? '' : '$' + (Math.round(this.state.currentCycleFeePer1KVE * this.state.userVEAmount / 1000 * 0.7 * this.lastPolRatio * 1000000) / 1000000)}</span></div>
              <div className="text-base font-light py-1 text-stone-400">Your End-of-Cycle Reward Estimation:  <span className="text-white">{this.getUserCurrentCycleReward()}</span></div>
              <div className="text-base font-light py-1 text-stone-400">Hypothetical LFNTY APR(see FAQ):  <span className="text-white">{this.state.currentCycleLFAPR}</span></div>
              <div className="text-base font-light py-1 text-stone-400">Hypothetical xLFNTY APR(see FAQ):  <span className="text-white">{this.state.currentCyclexLFAPR}</span></div>
            </div>
          </div>
        </figure>
      </div>
    );
  }
  /*render() {
    return (
      <div>
        <div className="flex">
          <h3 className="pl-2 text-xl font-semibold tracking-wide">Your veLFNTY Balance:</h3>
          <div className="sm:px-6 relative"><input className="px-2 input-d" type="text" onChange={this.onveAmountChange} onFocus={this.onveAmountFocus} value={this.state.userVEAmount === -1 ? 'enter veLFNTY amount' : (this.state.userVEAmount === 0 ? '' : this.state.userVEAmount)}></input></div>
        </div>
        <figure className="card mt-5 flex flex-col p-4 md:p-8">
          <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
            <div>
              <div className="mb-2 text-2xl">Last Cycle {this.getCyclePeriod(this.state.lastCycleStartDate)}</div>
              <div className="text-base font-light py-1 text-stone-400" onMouseEnter={(e) => { this.toggleInfoPanel(0, true, e) }} onMouseLeave={(e) => { this.toggleInfoPanel(0, false, e) }}>Total Fees:  <span className="text-white">{this.state.lastCycleTotalFee === 0 ? 'updating...' : '$' + numberWithCommas(this.state.lastCycleTotalFee)}</span></div>
              <div className="text-base font-light py-1 text-stone-400">POL Ratio (as of {this.lastPolRatioDate}):  <span className="text-white">{Math.round(this.lastPolRatio * 100000) / 1000}%</span></div>
              <div className="text-base font-light py-1 text-stone-400">Fees Distribution between FOL & POL:  <span className="text-white">${numberWithCommas(Math.round(this.state.lastCycleTotalFee * (1 - this.lastPolRatio) * 100) / 100)} + ${numberWithCommas(Math.round(this.state.lastCycleTotalFee * this.lastPolRatio * 100) / 100)}</span></div>
              <div className="text-base font-light py-1 text-stone-400" onMouseEnter={(e) => { this.toggleInfoPanel(1, true, e) }} onMouseLeave={(e) => { this.toggleInfoPanel(1, false, e) }}>Daily Average veLFNTY:  <span className="text-white">{this.state.lastCycleAvgVE === 0 ? 'updating...' : numberWithCommas(this.state.lastCycleAvgVE)}</span></div>
              <div className="text-base font-light py-1 text-stone-400">Your veLFNTY:  <span className="text-white">{isNaN(this.state.userVEAmount) || this.state.userVEAmount <= 0 ? 'please input your veLFNTY balance' : numberWithCommas(this.state.userVEAmount)}</span></div>
              <div className="text-base font-light py-1 text-stone-400">Your veLFNTY Share:  <span className="text-white">{isNaN(this.state.userVEAmount) || this.state.userVEAmount <= 0 ? '' : (this.state.userVEAmount / this.state.lastCycleAvgVE * 100).toString() + '%'}</span></div>
              <div className="text-base font-light py-1 text-stone-400">Your Reward Estimation:  <span className="text-white">{this.getUserLastCycleReward()}</span></div>
            </div>
            <div>
              <div className="mb-2 text-2xl">Current Cycle {this.getCyclePeriod(this.state.currentCycleStartDate)}</div>
              <div className="text-base font-light py-1 text-stone-400" onMouseEnter={(e) => { this.toggleInfoPanel(2, true, e) }} onMouseLeave={(e) => { this.toggleInfoPanel(2, false, e) }}>Fees Until Now:  <span className="text-white">{this.state.currentCycleTotalFee === 0 ? 'updating...' : '$' + numberWithCommas(this.state.currentCycleTotalFee)}</span></div>
              <div className="text-base font-light py-1 text-stone-400">Extrapolated Fees of This Cycle:  <span className="text-white">{this.state.currentCycleTotalFee === 0 ? 'updating...' : '~$' + numberWithCommas(Math.round(this.state.currentCycleTotalFee / this.state.daysInCurrentCycle * this.state.totalDaysInCurrentCycle * 1000000) / 1000000)}</span></div>
              <div className="text-base font-light py-1 text-stone-400" onMouseEnter={(e) => { this.toggleInfoPanel(4, true, e) }} onMouseLeave={(e) => { this.toggleInfoPanel(4, false, e) }}>Last 7D Fees Distri. btw. FOL & POL:  <span className="text-white">~${numberWithCommas(Math.round(this.state.last7DTotalFee * (1 - this.lastPolRatio) * 100) / 100)} + ~${numberWithCommas(Math.round(this.state.last7DTotalFee * this.lastPolRatio * 100) / 100)}</span></div>
              <div className="text-base font-light py-1 text-stone-400" onMouseEnter={(e) => { this.toggleInfoPanel(3, true, e) }} onMouseLeave={(e) => { this.toggleInfoPanel(3, false, e) }}>Daily Average veLFNTY:  <span className="text-white">{this.state.currentCycleAvgVE === 0 ? 'updating...' : numberWithCommas(this.state.currentCycleAvgVE)}</span></div>
              <div className="text-base font-light py-1 text-stone-400">Your veLFNTY Share:  <span className="text-white">{isNaN(this.state.userVEAmount) || this.state.userVEAmount <= 0 ? '' : (this.state.userVEAmount / this.state.currentCycleAvgVE * 100).toString() + '%'}</span></div>
              <div className="text-base font-light py-1 text-stone-400">Your Current Reward Estimation:  <span className="text-white">{(this.state.currentCycleTotalFee === 0 || this.state.currentCycleAvgVE === 0 || isNaN(this.state.userVEAmount) || this.state.userVEAmount <= 0) ? '' : '$' + (Math.round(this.state.currentCycleFeePer1KVE * this.state.userVEAmount / 1000 / 2 * this.lastPolRatio * 1000000) / 1000000)}</span></div>
              <div className="text-base font-light py-1 text-stone-400">Your End-of-Cycle Reward Estimation:  <span className="text-white">{this.getUserCurrentCycleReward()}</span></div>
              <div className="text-base font-light py-1 text-stone-400">Please be noted the estimation for this month is inaccurate due to Linfinity DAO buying out Flare DAO</div>
            </div>
          </div>
        </figure>
      </div>
    );
  }*/
}
/**
{isHovering && (
          <div>
            <h2>Only visible when hovering div</h2>
          </div>
        )}

 */

class FAQPanel extends React.Component {
  constructor(props) {
    super(props);
    //to update: this.setState({...this.state.lastCycle, totalFees: 'someothername'});
    this.state = {
      answer: '',
    }
  }

  showAnswer = (i) => {
    const answers = [
      'The calculator requests data from the official Lifinity Dashboard and keeps a record of both fees and total veLFNTY on a daily basis. With these data it\'s possible to estimate your reward based on your veLFNTY balance. Thanks to bigbrain Durden pointing out this approach so I don\'t have to mess with millions of transaction data on chain',
      'The formula is simple: daily_reward = (Fees on Day X) * (Your Share of veLNFTY on Day X) / 2 * (POL ratio), then cumulate daily_reward for all the days in that cycle, as half of the fees will be used to buy back LFNTY rather than to distribute to veLNFTY holders and the fees actually include those generated by FOL(Flare Owned Liquidity) which won\'t be distributed.\nIn terms of End-of-Cycle Reward, it\'s (Current Reward) / (current days of this cycle) * (total days in this cycle)',
      'Data of a certain day might be missing. In such a case, the calculator will presume the missing part of data based on what it has for the day before and after',
      'Because the APR is based on the assumption that you\'ve bought and locked your (x)LFNTY for 4 years from day 1 of the corresponding cycle at the current market price, which you actually can\'t. It\'s just a convenient way for you to have a rough estimation about the return you could expect',
      'Reward is affected by many factors. For example, data are gathered and calculated daily but in reality veLNFTY amount may vary every few minutes; FOL/POL ratio may also change and we can only infer the fees of the current month based on last month\'s FOL/POL ratio',
      //'Generally, yes. You can tag me (@oddcoder) on Twitter if you find a bug. The most recent update of this tool happened on 2024-02-22: now the calculator fetches (x)LFNTY price from Jupiter to help calculate APR',
      'Generally, yes. You can tag me (@oddcoder) on Twitter if you find a bug. The most recent update of this tool was pushed on 2025-10-29: updated distribution percentage and ratio according to October revenue',
    ];
    this.setState({
      answer: answers[i],
    });
  }

  render() {
    return (
      <div>
        <h3 className="pl-2 text-xl font-semibold tracking-wide">FAQ</h3>
        <figure className="card mt-5 flex flex-col p-4 md:p-8">
          <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
            <div>
              <div className="mb-2 text-2xl">Questions</div>
              <div className="text-base font-light py-1" onMouseEnter={(e) => { this.showAnswer(0) }}>How does this calculator work?</div>
              <div className="text-base font-light py-1" onMouseEnter={(e) => { this.showAnswer(1) }}>How is reward calculated?</div>
              <div className="text-base font-light py-1" onMouseEnter={(e) => { this.showAnswer(2) }}>What does "data presumed" mean?</div>
              <div className="text-base font-light py-1" onMouseEnter={(e) => { this.showAnswer(3) }}>Why the (x)LFNTY APR is "Hypothetical"?</div>
              <div className="text-base font-light py-1" onMouseEnter={(e) => { this.showAnswer(4) }}>Why can't this be accurate?</div>
              <div className="text-base font-light py-1" onMouseEnter={(e) => { this.showAnswer(5) }}>Is this calculator actively maintained?</div>
            </div>
            <div>
              <div className="mb-2 text-2xl">Answer</div>
              <div className="text-base font-light py-1">{this.state.answer.split('\n').map(str => <p key={str}>{str}</p>)}</div>
            </div>
          </div>

        </figure>
      </div>
    );
  }
}

class App extends React.Component {
  constructor(props) {
    super(props);
    this.refMonthlyDataPanel = React.createRef();
    this.state = {
      count: 0,
      delay: 1,
      infoPanelVisible: false,
      infoPanelContent: '',
      infoPanelX: 0,
      infoPanelY: 0,
    }
  }

  componentDidMount() {
    document.title = 'Lifinity Reward Calculator';
    this.setTimeOutHandle = setTimeout(this.tick, this.state.delay);
  }

  componentWillUnmount() {
    if (this.setTimeOutHandle) clearTimeout(this.setTimeOutHandle);
  }

  tick = () => {
    this.setTimeOutHandle = null;
    if (this.state.delay === 1) this.setState({ delay: 30000 });
    fetch('https://lifinity.never-note.com/lifistat').then(data => data.json()).then(data => {
      this.setState({
        count: this.state.count + 1
      });
      this.refMonthlyDataPanel.current.updateDataSource(data);
    }).catch().finally(() => { this.setTimeOutHandle = setTimeout(this.tick, this.state.delay); });
  }

  updateInfoPannel = (visible, content, x, y) => {
    this.setState({
      infoPanelVisible: visible,
      infoPanelContent: content,
      infoPanelX: x + 20,
      infoPanelY: y - 150,
    });
  }

  render() {
    return (
      <div className="flex min-h-screen flex-col">
        <nav className="z-20">
          <div className="mx-auto max-w-7xl px-4 pt-2 sm:px-6 lg:px-8">
            <div className="flex h-16 items-center">
              <div className="flex flex-1 items-center">
                <div className="flex-shrink-0 ">
                  <h3 className="pl-2 text-xl font-semibold tracking-wide text-neutral-200">Lifinity Reward Calculator</h3>
                </div>
              </div>
            </div>
          </div>
        </nav>
        <main className="h-full p-1 text-neutral-200 sm:px-2 sm:py-1 md:px-2 md:py-1 xl:px-4">
          <div className="container">
            <div className="bg-normal"></div>
            <div className="custom-tooltip-frame" style={{ pointerEvents: 'none', visibility: (this.state.infoPanelVisible ? 'visible' : 'hidden'), position: 'absolute', top: this.state.infoPanelY.toString() + 'px', left: this.state.infoPanelX.toString() + 'px' }}><div>{this.state.infoPanelContent.split('\n').map(str => <p key={str}>{str}</p>)}</div></div>
            <main classs="relative">
              <div className="flex flex-col space-y-10 p-4 md:p-8">
                <MonthlyDataPanel ref={this.refMonthlyDataPanel} updateInfoPannel={this.updateInfoPannel} />
                <FAQPanel />
              </div>
            </main>
          </div>
        </main>
      </div>
    );
  }
}


export default App;
